import { z } from "zod";

export const enableLayersToolSchema = {
  inputSchema: z.object({
    layerIds: z.array(z.string()).describe("Array of layer IDs to enable"),
  }),
  outputSchema: z.object({
    success: z.boolean().describe("Whether the layers were successfully enabled"),
  }),
};

export type EnableLayersToolInput = z.infer<typeof enableLayersToolSchema.inputSchema>;
export type EnableLayersToolOutput = z.infer<typeof enableLayersToolSchema.outputSchema>;
